// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/social_icons.sass
// module id = 221
// module chunks = 0